import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wi-data-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wi-data-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./wi-data-modal.component.scss'],
})
export class DataModalComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() width = '640px';
  @Input() closeOnBackdrop = true;
  @Input() closeOnEsc = true;
  @Input() showCloseButton = true;
  @Input() customHeader = false;
  @Input() panelClass = '';
  @Input() ariaLabel = '';
  @Input() dialogId = '';
  @Input() bodyClass = '';

  @Output() readonly modalClose = new EventEmitter<void>();

  private bodyScrollY = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    }
  }

  ngOnDestroy(): void {
    // Always clear in case the host is destroyed via *ngIf before isOpen propagates to false.
    this.unlockScroll();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEsc(ev: Event): void {
    if (!this.isOpen || !this.closeOnEsc) {
      return;
    }
    ev.preventDefault();
    this.close();
  }

  onBackdropClick(ev: MouseEvent): void {
    if (!this.closeOnBackdrop) {
      return;
    }
    const t = ev.target as HTMLElement;
    if (t.classList.contains('app-transaction-modal-backdrop')) {
      this.close();
    }
  }

  onDialogClick(ev: MouseEvent): void {
    ev.stopPropagation();
  }

  close(): void {
    this.modalClose.emit();
  }

  get dialogAriaLabel(): string {
    return this.ariaLabel?.trim() || this.title || 'Dialog';
  }

  private lockScroll(): void {
    if (typeof document === 'undefined') {
      return;
    }
    this.bodyScrollY = window.scrollY;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.bodyScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  private unlockScroll(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, this.bodyScrollY);
  }
}
